import { CHAIN_ID } from '@derivation-tech/context';
import { createAction } from '@reduxjs/toolkit';
import { HISTORY_RANGE } from './constants';

export const setHistoryRange = createAction<HISTORY_RANGE>('graph/setHistoryRange');
export const resetHistory = createAction<{ chainId: CHAIN_ID }>('graph/resetHistory');
